import {
	Component,
	ElementRef,
	ViewEncapsulation,
	ChangeDetectorRef,
	Renderer,
	forwardRef,
	ViewChild
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { IMyDate } from 'mydatepicker/dist/interfaces/my-date.interface';
import { MyDatePicker } from 'mydatepicker';
import { LocaleService } from 'mydatepicker/dist/services/my-date-picker.locale.service';
import { UtilService } from 'mydatepicker/dist/services/my-date-picker.util.service';

export const MYDP_VALUE_ACCESSOR: any = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => SnDatePickerComponent),
	multi: true
};

@Component({
	selector: 'sn-date-picker',
	template: require('./sn-date-picker.component.html'),
	styles: [require('./sn-date-picker.component.scss')],
	providers: [LocaleService, UtilService, MYDP_VALUE_ACCESSOR],
	encapsulation: ViewEncapsulation.None
})
export class SnDatePickerComponent extends MyDatePicker {
	@ViewChild('selectorEl') snDatePicker: ElementRef;

	constructor(
		public _elem: ElementRef,
		private _renderer: Renderer,
		private _cdr: ChangeDetectorRef,
		private _localeService: LocaleService,
		private _utilService: UtilService
	) {
		super(_elem, _renderer, _cdr, _localeService, _utilService);
	}

	inputClicked(e) {
		if (this.snDatePicker) {
			return;
		}
		this.openBtnClicked();
		setTimeout(() => {
			e.target.focus();
		}, 0);
	}

	onUserDateInput(value: string): void {
		if (value.length === 0) {
			if (this._utilService.isInitializedDate(this.selectedDate)) {
				this.clearDate();
			} else {
				this.invalidInputFieldChanged(value);
			}
		} else {
			const date: IMyDate = this._utilService.isDateValid(
				value,
				this.opts.dateFormat,
				this.opts.minYear,
				this.opts.maxYear,
				this.opts.disableUntil,
				this.opts.disableSince,
				this.opts.disableWeekends,
				this.opts.disableWeekdays,
				this.opts.disableDays,
				this.opts.disableDateRanges,
				this.opts.monthLabels,
				this.opts.enableDays
			);
			if (this._utilService.isInitializedDate(date)) {
				if (!this._utilService.isSameDate(date, this.selectedDate)) {
					this.selectDate(date);
				} else {
					this.updateDateValue(date);
				}
			} else {
				this.invalidInputFieldChanged(value);
			}
		}
	}

	selectDate(date: IMyDate, closeReason?: number): void {
		this.updateDateValue(date);
		if (this.showSelector && closeReason) {
			this.calendarToggle.emit(closeReason);
			this.showSelector = false;
		} else {
			this.setVisibleMonth();
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/common/sn-date-picker/sn-date-picker.component.ts